import { createFileRoute } from '@tanstack/react-router';

import { NavigationBar } from '@/features/settings';
import { toOrganizationId, useGetOrganization } from '@/hooks/api';
import { OrganizationProvider } from '@/store';

const OrganizationWrapper = () => {
  const { data: organization } = useGetOrganization(toOrganizationId('me'));

  if (!organization) return null;

  return (
    <OrganizationProvider {...organization}>
      <NavigationBar />
    </OrganizationProvider>
  );
};

export const Route = createFileRoute('/_auth/_org/settings')({
  component: OrganizationWrapper,
});
